import { SitterDetail } from 'modules/Accounts';
import React from 'react';

export function SitterDetailAC() {
  return (
    <React.Fragment>
      <SitterDetail isSitterAC />
    </React.Fragment>
  );
}

export default SitterDetailAC;
